import React from 'react';
import { motion } from 'framer-motion';
import { origins } from '../data/storeData';

const OriginCards = () => {
  return (
    <section id="origins" className="bg-tea-stone/20 py-24 md:py-32 px-6 border-y border-tea-stone/50">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 md:mb-24"
        >
          <span className="text-jade uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">Terroir</span>
          <h2 className="text-3xl md:text-5xl font-serif text-plum-dark mb-6">Tasting Origins</h2>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed text-sm md:text-base">
            Every leaf tells the story of its landscape. Discover the unique characteristics imparted by our carefully selected partner farms.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {origins.map((origin, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="bg-moon-white p-6 md:p-8 shadow-sm hover:shadow-xl transition-shadow duration-500 rounded-sm group"
            >
              <div className="aspect-[4/3] overflow-hidden mb-8 rounded-sm">
                <img 
                  src={origin.image} 
                  alt={origin.region} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
                />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-plum-dark mb-4 pb-4 border-b border-tea-stone/60">
                {origin.region}
              </h3>
              <p className="text-gray-600 text-sm leading-loose">
                {origin.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OriginCards;